import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, TransferRequestsApi, type TransferReasonsResponse } from '@shared/api';

const getTransferReasonsEffect = createEffect(() => TransferRequestsApi.getTransferReasons());
const clearEvent = createEvent();

const $dataStore = createStore<TransferReasonsResponse[]>([])
  .on(getTransferReasonsEffect.done, (current, values) => values.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransferReasonsEffect.pending, (_, data) => data)
  .on(getTransferReasonsEffect.fail, () => false)
  .on(getTransferReasonsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransferReasonsEffect, () => null)
  // .on(getTransferReasonsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransferReasonsEffect.fail, () => 'Something went wrong while fetching Transfer Reasons. Please try again.')
  .on(getTransferReasonsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferReasonsStore = {
  events: {
    getTransferReasons: ApiUtils.wrapperApi(getTransferReasonsEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
